import { render, staticRenderFns } from "./SectionImport.vue?vue&type=template&id=713aad7f&"
import script from "./SectionImport.vue?vue&type=script&lang=js&"
export * from "./SectionImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports